import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/UI/Button';
import { Box } from '@/layout';
import { Modal } from '@mui/material';

import { ModalActions, ModalForm, ModalTitle } from '../style';
import { successHandler, errorHandler } from '@/utils/toastHandler';
import { Close } from '@/components/Icon';
import { InputWrapper } from '@/components/Container/AuthContainer/styles';
import { TextField } from '@mui/material';
import { createFolder } from '@/api/document.api';

interface TranscribeProps {
  previousFolderId: number | null;
  currentFolderId: number | null;
  show: boolean;
  setShowAddNewFolderModal: (show: boolean) => void;
  getDocuments: (id: number | null) => void;
}

const AddNewFolder = ({ currentFolderId, previousFolderId, show, setShowAddNewFolderModal, getDocuments }: TranscribeProps) => {
  // @ts-ignore
  const { t } = useTranslation();

  const {
    control,
    resetField,
    handleSubmit
  } = useForm<{ name: string }>();

  const onSubmit = handleSubmit(async (data) => {
    try {
      const res = (await createFolder({ name: data.name, parent_id: currentFolderId })).data;
      if (res.success) {
        getDocuments(currentFolderId);
        // successHandler(t('success.addFolder'));
        successHandler('Add Folder Success');
        resetField('name');
        setShowAddNewFolderModal(false);
      }
    } catch (error: any) {
      console.log(error);
      errorHandler('Add Folder Failed: ' + error.response.data.data);
    }
  });

  return (
    <Modal
      open={show}
      onClose={() => setShowAddNewFolderModal(false)}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      disableEnforceFocus
    >
      <ModalForm onSubmit={onSubmit}>
        <Close.ButtonClose
          type="button"
          onClick={() => {
            setShowAddNewFolderModal(false);
          }}
        >
          <Close.CloseSVG />
        </Close.ButtonClose>
        <ModalTitle>Add folder</ModalTitle>
        <InputWrapper style={{ height: 'auto' }}>
          <Controller
            control={control}
            name={'name'}
            defaultValue={''}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <TextField
                label={t('form.name.label')}
                variant="standard"
                value={value}
                sx={{ width: '100%' }}
                onChange={onChange}
                error={!!error}
                helperText={error ? error.message : null}
                autoComplete="off"
              />
            )}
          />
        </InputWrapper>
        <ModalActions>
          <Button type="submit" size={'lg'} variant={'primary'} rounded={false}>
            {t('buttons.ok')}
          </Button>
          <Button
            type="button"
            size={'lg'}
            variant={'primary-invert'}
            color="primary"
            onClick={() => setShowAddNewFolderModal(false)}
            style={{ textDecoration: 'underline' }}
          >
            {t('buttons.cancel')}
          </Button>
        </ModalActions>
      </ModalForm>
    </Modal>
  );
};

export default AddNewFolder;
